import React, { ReactNode } from "react";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import Section from "@insightfulscience/atomic-react/Section";
import { bgColor4 } from "@insightfulscience/atomic-react/utils/color";
import { LocaleProvider } from "@insightfulscience/i18";

import SiteLayout from "../SiteLayout";
import locales from "./locales";

export type ErrorLayoutProps = {
	children: ReactNode | ReactNode[];
	extra?: ReactNode | ReactNode[];
};

function ErrorLayout({ children, extra }: ErrorLayoutProps) {
	return (
		<LocaleProvider resources={locales}>
			<SiteLayout>
				<SimpleTemplate shadow={false} bgColor={bgColor4}>
					{children}
				</SimpleTemplate>
				{extra && (
					<Section className="pt-9 pt-9--md pb-18 pb-18--md">{extra}</Section>
				)}
			</SiteLayout>
		</LocaleProvider>
	);
}

export type ErrorLayoutPureProps = ErrorLayoutProps;

function ErrorLayoutPure({ children, extra }: ErrorLayoutPureProps) {
	return (
		<SiteLayout.Pure>
			<SimpleTemplate shadow={false} bgColor={bgColor4}>
				{children}
			</SimpleTemplate>
			{extra && (
				<Section className="pt-9 pt-9--md pb-18 pb-18--md">{extra}</Section>
			)}
		</SiteLayout.Pure>
	);
}

ErrorLayout.Pure = ErrorLayoutPure;

export default ErrorLayout;
